export const commonStyling = {
    animation: 'none',
    transition: 'none',
    borderRadius: '100px',
    '& .MuiInputBase-root': {
        borderRadius: '100px',
        padding: '20px 60px',
    },
    '& .MuiInputBase-root *': {
        border: 'none',
        outline: 'none'
    },
    border: 'none',
    outline: 'none',
    backgroundColor: '#F6F6F6',
    width: "100%",
    position: 'relative',
}